import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface ChartButtonProps extends ButtonProps {
    text: string;
    onClick: () => void;
    sx?: SxProps<Theme>;
}

const ChartButton: React.FC<ChartButtonProps> = ({
    text,
    onClick,
    sx = {},
    ...rest
}) => (
    <Button
        type="button"
        sx={{
            color: 'white',
            background: 'linear-gradient(to bottom, #0870b4, #0870b4)', // Example colors
            px: 2,
            py: 2, // Adjust padding if needed
            height: 44,
            borderRadius: 2,
            transition: 'transform 0.3s ease-in-out',
            transform: 'scale(1)',
            '&:hover': {
                transform: 'scale(1.05)',
                background: 'linear-gradient(to bottom, #0870b4, #0870b4)', // Example reversed gradient
                color: 'white',
            },
            '&:focus': {
                outline: 'none',
            },
            ...sx, // Ensure this is correctly merging styles
        }}
        onClick={onClick}
        {...rest}
    >
        {text}
    </Button>
);

export default ChartButton;
